import React from 'react';
import { Form, validate, renderFields } from '@tpr/forms';
import { Footer } from '../../../components/card';
import { Content } from '../../../components/content';
import { ArrowButton } from '../../../../buttons/buttons';
var ContactDetails = function (_a) {
    var type = _a.type, typeName = _a.typeName, title = _a.title, subtitle = _a.subtitle, sectionTitle = _a.sectionTitle, loading = _a.loading, onSubmit = _a.onSubmit, initialValues = _a.initialValues, fields = _a.fields;
    return (React.createElement(Content, { type: type, typeName: typeName, title: title, subtitle: subtitle, loading: loading, sectionTitle: sectionTitle },
        React.createElement(Form, { onSubmit: onSubmit, initialValues: {
                telephoneNumber: initialValues.telephoneNumber,
                emailAddress: initialValues.emailAddress,
            }, validate: validate(fields) }, function (_a) {
            var handleSubmit = _a.handleSubmit;
            return (React.createElement("form", { onSubmit: handleSubmit, "data-testid": type + "-contact-form" },
                renderFields(fields),
                React.createElement(Footer, null,
                    React.createElement(ArrowButton, { appearance: "secondary", pointsTo: "up", iconSide: "right", type: "submit", title: "Save and close", disabled: loading }))));
        })));
};
export default React.memo(ContactDetails);
//# sourceMappingURL=contactDetails.js.map